module.exports = __webpack_public_path__ + "img/login.f2c79edb.png";